/**
 * KDS Text Area — Figma node 1078:11889 (component set 193:619).
 *
 * Figma axes: State (Default, Hover, Active, Focused, Disabled, Error) and Filled (No/Yes).
 * No size variant on the Text Area component — one control scale only.
 */

/** Figma sm-radius — 6px (`radii.md`). */
export const textAreaBorderRadius = 'md';

/** Horizontal padding — Figma sm (8px). */
export const textAreaPaddingX = '2';

/** Default vertical padding — Figma xs top (6px), sm bottom (8px). */
export const textAreaPaddingTop = '1.5';
export const textAreaPaddingBottom = '2';

/**
 * Figma color tokens for the textarea control (193:619).
 * Label / error message colors live on `Field` slots — see `fieldSlotRecipe`.
 */
export const textAreaColors = {
  background: 'neutral.0',
  text: 'neutral.500',
  placeholder: 'neutral.250',
  disabledBackground: 'neutral.50',
  border: {
    default: 'neutral.250',
    hover: 'neutral.350',
    active: 'brand.500',
    disabled: 'neutral.200',
    error: 'red.700',
  },
} as const;
